import BADGES from '../data/certificateBadges.json';

// The words on a certificate, from src/data/certificateBadges.json. The public
// verify page uses the same file and rule (server/certificateBadge.js).
export function certificateSubheading(courseId) {
  return BADGES.courses[courseId]?.subheading || BADGES.defaultSubheading;
}

// The badge under the course title: the course label, else its category,
// else "Certificate".
export function certificateBadge(courseId, category) {
  return BADGES.courses[courseId]?.label || category || 'Certificate';
}
